export const CHAT_MODES = {
  COMPOSE: 'COMPOSE',
  DETAIL: 'DETAIL',
};
